import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Store } from '@ngxs/store';

import { SetCurrentCodeSection, SetCurrentCodePage } from '../shared/navigation.state';
import { GtmService } from '../shared/services/gtm.service';
import { AssuranceApiService } from '../assurance-habitation/services/assurance-api.service';
import { GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES } from '../shared/modeles/variables';
import { HideLoader, PersonneState, ShowLoader } from '../shared/personne.state';
import { MPM_ASSURANCE_SOUMISSION } from '../../configs/toggles.config';

@Component({
  selector: 'app-acte-vente',
  templateUrl: './acte-vente.component.html',
  styleUrls: ['./acte-vente.component.scss'],
  standalone: false
})
export class ActeVenteComponent implements OnInit, AfterViewInit {
  MPM_ASSURANCE_SOUMISSION = MPM_ASSURANCE_SOUMISSION;

  public isAppleMobile = false;
  public isAndroid = false;

  constructor(
    private readonly _store: Store,
    private readonly _gtm: GtmService,
    private readonly _assuranceService: AssuranceApiService
  ) {}

  ngOnInit() {
    this._store.dispatch(new SetCurrentCodeSection('ACTEV'));
    this._store.dispatch(new SetCurrentCodePage('acte_vente'));
  }

  ngAfterViewInit() {
    Promise.resolve(null).then(() => this.detectDevice());
  }

  detectDevice() {
    this.isAppleMobile = PersonneState.IS_IPAD() || PersonneState.IS_IPHONE();
    this.isAndroid = PersonneState.IS_ANDROID();
  }

  private sendInsuranceAnalytic() {
    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: 'Parcours habitation',
      label: 'Mon acte de vente - Proteger ma maison',
      action: 'Obtenir une soumission',
      value: 0,
      nonInteraction: false
    });
  }

  onClickInsuranceInquiry() {
    this._store.dispatch(new ShowLoader('page'));
    this.sendInsuranceAnalytic();

    this._assuranceService.getInsuranceQuotationUrl().subscribe(requestUrl => {
      window.location.href = requestUrl;
      this._store.dispatch(new HideLoader());
    });
  }
}
